import { render } from "./PaginaInicial.vue?vue&type=template&id=283386d2&scoped=true"
import script from "./PaginaInicial.vue?vue&type=script&lang=js"
export * from "./PaginaInicial.vue?vue&type=script&lang=js"

import "./PaginaInicial.vue?vue&type=style&index=0&id=283386d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283386d2"]])

export default __exports__